// Test IDs for Tasks feature
export const TASKS = {
    newTaskButton: "task-new-button",
    createModal: "task-create-modal",
    titleInput: "task-title-input",
    descriptionInput: "task-description-input",
    briefInput: "task-brief-input",
    assigneeSelect: "task-assignee-select",
    brandSelect: "task-brand-select",
    contentTypeSelect: "task-content-type-select",
    aspectSelect: "task-aspect-select",
    createSubmit: "task-create-submit",
    createCancel: "task-create-cancel",
    column: (status) => `task-column-${status}`,
    card: (id) => `task-card-${id}`,
    detailPanel: "task-detail-panel",
    detailTitle: "task-detail-title",
    statusSelect: "task-status-select",
    statusNote: "task-status-note",
    saveStatus: "task-save-status",
    commentInput: "task-comment-input",
    commentSubmit: "task-comment-submit",
    updateItem: (i) => `task-update-${i}`,
    runInForge: "task-run-in-forge",
    linkRunButton: "task-link-run",
};

export const LLMKEYS = {
    keySourceEmergent: "key-source-emergent",
    keySourceCustom: "key-source-custom",
    inputOpenAI: "provider-key-openai",
    inputAnthropic: "provider-key-anthropic",
    inputGemini: "provider-key-gemini",
    revealToggle: (p) => `provider-key-reveal-${p}`,
    clearButton: (p) => `provider-key-clear-${p}`,
};
